/* Bisous & Co — panier (07/09/2026).
   Le bouton Checkout va directement a /checkout au lieu de POST /cart puis redirection :
   un aller-retour serveur de moins avant la page de paiement. La note panier est
   desactivee dans le theme, rien n'est perdu en sautant le POST.
   (L'ouverture anticipee du tiroir a ete essayee puis retiree le 07/09 : l'article
   n'arrive pas plus vite, l'attente ne faisait que changer de place.) */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    btn.setAttribute('aria-busy', 'true');
    /* Cadeaux BFCM (07/10/2026) : le panier est remis d'aplomb (cadeaux du bon palier,
       quantite 1) avant de partir au checkout. Sans le script, depart direct. */
    var guard = window.BSGifts && window.BSGifts.guard;
    var ready = guard ? guard().catch(function () {}) : Promise.resolve();
    ready.then(function () { window.location.assign('/checkout'); });
  }, true);

  /* Continue shopping (09/09/2026), facon Comfrt : dans le tiroir, le lien ferme
     simplement le panier. Hors tiroir (page /cart), il navigue normalement. */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('[data-bs-continue]') : null;
    if (!link) return;
    var drawer = link.closest('cart-drawer-component');
    if (!drawer) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof drawer.close === 'function') drawer.close();
    else if (typeof drawer.closeDialog === 'function') drawer.closeDialog();
  }, true);
})();
